import { render, staticRenderFns } from "./PositionsCard.vue?vue&type=template&id=5d3707cd&scoped=true"
import script from "./PositionsCard.vue?vue&type=script&lang=js"
export * from "./PositionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3707cd",
  null
  
)

export default component.exports